import axios from "axios";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import "./Homepage.scss";
import { UserContext } from "../../Context/UserContextAPI";
import { Link } from "react-router-dom";
import ApexCharts from "apexcharts";
import useSubscriptionExpired from "../../hooks/useSubscriptionExpired";
import SubscriptionExpiredShow from "../Accounts/SubscriptionPayment/SubscriptionExpiredShow";
import IconGroupInHomePage from "./IconGroupInHomePage";

const Homepage = () => {
  const settingURL = `${process.env.REACT_APP_API_BASE_URL}/settings`;
  // const smsBalanceAPI = `https://api.greenweb.com.bd/g_api.php?token=${process.env.REACT_APP_SMS_API_TOKEN}&balance`;
  const chartRef = useRef();
  const pieRef = useRef();
  const [chartUserDetails, setChartUserDetails] = useState([]);
  const [pieUserDetails, setPieUserDetails] = useState([]);
  const [data, setData] = useState({});
  const [smsBalance, setSMSBalance] = useState();
  const [vatId, setVatId] = useState(0);
  const [statusCounts, setStatusCounts] = useState({
    status1: 0,
    status2: 0,
    status3: 0,
    status4: 0,
  });
  const [totalStatus, setTotalStatus] = useState(0);
  const { accessPerm } = useContext(UserContext);

  const getData = () => {
    axios
      .get(settingURL)
      .then((response) => {
        const allData = response.data.data[0];
        setData(allData);
        setVatId(allData.vat_type);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // const getSMSBalance = () => {
  //   axios
  //     .get(smsBalanceAPI)
  //     .then((response) => {
  //       setSMSBalance(response?.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  const getChartUserDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user-details/chart/all`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      );
      console.log(response?.data);
      setChartUserDetails(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getPieUserDetails = async () => {
    console.log("called");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user-details/pie/all`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage?.getItem("jwtToken")}`,
          },
        }
      );
      console.log(response?.data);
      setPieUserDetails(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const showChart = useCallback(() => {
    const totalCount = chartUserDetails?.totalCount || 0;
    const fitCount = chartUserDetails?.fitCount || 0;
    const unfitCount = chartUserDetails?.unfitCount || 0;
    const heldupCount = chartUserDetails?.heldupCount || 0;
    const processingCount = chartUserDetails?.processingCount || 0;

    console.log("Chart Data:", {
      fitCount,
      unfitCount,
      heldupCount,
      processingCount,
    });

    const options = {
      chart: {
        type: "bar",
      },
      series: [
        {
          name: "Patient",
          data: [
            totalCount,
            fitCount,
            unfitCount,
            heldupCount,
            processingCount,
          ],
        },
      ],
      xaxis: {
        categories: ["TOTAL", "FIT", "UNFIT", "HELDUP", "PROCESSING"],
      },
      yaxis: {
        min: 0,
        max: 200,
        tickAmount: 5,
        labels: {
          formatter: function (value) {
            return value;
          },
        },
      },
      plotOptions: {
        bar: {
          distributed: true,
          dataLabels: {
            position: "top",
          },
          columnWidth: "80%",
        },
      },
      colors: ["#fff200", "#008000", "#FF0000", "#0000FF", "#000000"], // Colors corresponding to TOTAL, FIT, UNFIT, HELDUP, PROCESSING
      dataLabels: {
        enabled: true,
        formatter: function (value) {
          return value;
        },
        offsetY: -40,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
    };

    if (chartRef.current) {
      // Destroy existing chart instance if it exists
      if (chartRef.current.chart) {
        chartRef.current.chart.destroy();
      }
      // Initialize new chart instance
      const chart = new ApexCharts(chartRef.current, options);
      chart.render();
      chartRef.current.chart = chart; // Store chart instance in ref
    }
  }, [chartUserDetails]);

  const showPie = useCallback(() => {
    const introducersCount = pieUserDetails?.introducersCount || 0;
    const representativesCount = pieUserDetails?.representativesCount || 0;
    const countriesCount = pieUserDetails?.countryCount || 0;

    const pieOptions = {
      series: [introducersCount, representativesCount, countriesCount],
      chart: {
        width: "100%",
        type: "pie",
      },
      labels: ["Introducers", "Representatives", "Countries"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
      legend: {
        position: "right",
        offsetY: 0,
        height: 230,
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -5,
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val, opts) {
          return opts.w.config.series[opts.seriesIndex];
        },
        dropShadow: {
          enabled: false,
        },
      },
      title: {
        text: "",
        align: "center",
        margin: 0,
        offsetY: 20,
        style: {
          fontSize: "22px",
        },
      },
    };

    if (pieRef.current) {
      // Destroy existing chart instance if it exists
      if (pieRef.current.pie) {
        pieRef.current.pie.destroy();
      }
      // Initialize new chart instance
      const pie = new ApexCharts(pieRef.current, pieOptions);
      pie.render();
      pieRef.current.pie = pie; // Store chart instance in ref
    }
  }, [pieUserDetails]);

  useEffect(() => {
    getData();
    // getSMSBalance();
    getChartUserDetails();
    getPieUserDetails();
  }, []);

  useEffect(() => {
    showChart();
  }, [chartUserDetails, showChart]);

  useEffect(() => {
    showPie();
  }, [pieUserDetails, showPie]);

  const { isExpiredWarningShow } = useSubscriptionExpired();

  return (
    <div className="p-2">
      {isExpiredWarningShow && <SubscriptionExpiredShow />}
      <div className="card">
        <div className="card-body">
          <div className="border p-3 rounded">
            <div className="card-box">
              <h6 className="mb-0 text-uppercase">DASHBOARD</h6>
            </div>
            <main>
              {/* <div className="container-fluid" style={{ maxHeight: "180px" }}>
            <div className="d-flex align-items-center justify-content-center py-5">
              <div className="row g-0">
                <div className="p-1 text-center">
                  <h2 className="mt-2 fs-4" style={{ color: "#128772" }}>
                    {data?.website_name}
                  </h2>
                  <p className="m-0 text-dark">Address: {data?.address}</p>
                  <p className="contact text-dark">Mobile: {data?.mobile}</p>
                </div>
              </div>
            </div>
          </div> */}
              <IconGroupInHomePage />
            </main>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="border p-3 rounded">
          <h6 className="card-title p-2 text-uppercase">
            Today's Patients Update
          </h6>
          <div className="card-body">
            <div className="card-box">
              <div className="d-flex w-100 justify-content-between">
                <div className="col-sm-6 border p-2" ref={chartRef}></div>
                <div
                  className="col-sm-5 d-flex align-items-center justify-content-center border"
                  ref={pieRef}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
